import { render, staticRenderFns } from "./additionalGoods.vue?vue&type=template&id=3670d5ea&scoped=true"
import script from "./additionalGoods.vue?vue&type=script&lang=js"
export * from "./additionalGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670d5ea",
  null
  
)

export default component.exports